import React from "react";
import { useTranslation } from "react-i18next";
import InternalLink from "../components/InternalLink";
import { INTEGRATION_SKILLS } from "./skillsData";

const IntegrationSkillsSection = () => {
    const { t } = useTranslation();

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
                {t("skillsPage.getMoreSkills")}
            </h2>
            <p className="text-sm text-gray-500">
                {t("skillsPage.getMoreSkillsDescription")}
            </p>
            <div className="space-y-4">
                {INTEGRATION_SKILLS.map((integration) => (
                    <div
                        key={t(integration.integrationName)}
                        className="border border-gray-200 rounded-xl p-5 bg-gray-50"
                    >
                        <div className="flex items-center gap-3 mb-3">
                            <span className="text-2xl">{integration.integrationIcon}</span>
                            <div>
                                <h3 className="font-semibold text-gray-900">
                                    {t(integration.integrationName)}
                                </h3>
                                <p className="text-sm text-gray-500">
                                    {t(integration.integrationDescription)}
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-3">
                            {integration.skills.map((skill) => (
                                <div key={skill.id} className="bg-white p-3 rounded-lg border border-gray-100">
                                    <div className="flex items-center gap-2">
                                        <span className="text-lg">{skill.icon}</span>
                                        <span className="font-medium text-sm text-gray-900">
                                            {t(skill.nameKey)}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="flex justify-center">
                            <InternalLink
                                to="/integrate"
                                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm rounded-lg hover:bg-blue-700 transition-colors"
                            >
                                {t("skillsPage.activate")} {t(integration.integrationName)}
                            </InternalLink>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IntegrationSkillsSection;
